export const REQUEST_SIMILAR_ITEMS =
  'feature/listing/SimilarItems/REQUEST_SIMILAR_ITEMS';
export const HANDLE_RESPONSE_SIMILAR_ITEMS =
  'feature/listing/SimilarItems/HANDLE_RESPONSE_SIMILAR_ITEMS';
export const HANDLE_RESPONSE_ERROR_SIMILAR_ITEMS =
  'feature/listing/SimilarItems/HANDLE_RESPONSE_ERROR_SIMILAR_ITEMS';
